export default __webpack_public_path__ + "static/media/logo-experiencias.0648c944.svg";